import ahsanSajidImage from "@/assets/ahsan-sajid.png";

export const AiCodingFounderQuote = () => {
  return (
    <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <img
          src={ahsanSajidImage}
          alt="Ahsan Sajid"
          className="w-14 h-14 rounded-full object-cover border-2 border-primary/20"
        />
        <div>
          <blockquote className="text-foreground italic leading-relaxed">
            "AI coding assistants have changed how we work, and the productivity gains are real. But I'm 
            selective about where to use them. Critical systems need human review — always. The key is knowing 
            which code needs a human brain and which just needs to work. That judgment comes from experience, 
            not from the AI itself."
          </blockquote>
          <div className="mt-4">
            <p className="font-semibold text-foreground">Ahsan Sajid</p>
            <p className="text-sm text-muted-foreground">Owner, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
